export class ContributorAddModel {
    public firstName: number;
    public lastName: string;
    public email: string;
    public address: string;
    public city: string;
    public country: string;
    public currency: string;
    public zipCode: string;
    public bankName: string;
    public accountNumber: string;
    public ifsc: string;
    public uniqueNumber: string;
    public password: string;
    public cpassword: string;
    public commission: number;
    public ipAddress: string;
    public state: string;
    public phone: string;
    public idNumber: string;
    public dateOfBirth: string;
    constructor() {
        this.country = '';
        this.currency = '';
    }
}
